import * as ServiceProviderEvents from "./sp-events.js";
import * as CitizenEvents from "./citizen-events.js";

let myEvents;
let eventHandlers;
let inviteeMydexID;
let context;
let contextID;
/**
 * Event Manager
 * @param {string} appType defines how we access and manage the events which is different for different types of apps i.e. Citizen vs Service Provider
 * @param {*} consumer object enables access the event handlers set by the consuming entity e.g. Calendar
 * 
 * @return eventManager object contains all the functions required for interacting with the EventManager entity
 * 
 */
export const EventManager = function (appType, consumer) {

  //what kinds of events are we wanting to access:
  if (appType == 'SP') {
    myEvents = ServiceProviderEvents.getServiceProviderEvents();
    // populateInviteeList(); // *Currently not in use*
  } else {
    myEvents = CitizenEvents.getCitizenEvents();
  }

  //handles setting the context/contextID once dom is loaded e.g. in the case of a Referral
  $(
    contextID = consumer.getContextID(),
    context = consumer.context
  );

  //gets the event handlers as defined by the consuming entity e.g. Calendar, Referrals
  eventHandlers = consumer.eventHandlers;
  //adds invitee list far inviting invitee to events
  
  
  //the event manager object that gets returned contains the events and functions that can be used by the consuming entity
  let eventManager = {

    events : myEvents.getEvents(),

    /**
     * shows the add-event-modal.html in the browser
     * 
     * @param {*} date optional parameter which, if passed, pre-populates the start and end date of the modal form
     */
    showAddEventModal : function(date, client) {

      $('.fc-popover').hide();
      $('.time-error').remove();
      $("#add-event-modal").modal("show");
      if (date) {
        $("#add-start-date").val(date.dateStr);
        $("#add-end-date").val(date.dateStr);
      }
      if (client) {
        $("#add-type-heading").html("Appointment");
        $("#add-invitee-heading").html(client['client-name']);
        inviteeMydexID = client['mydexid'];
      }

    },

    /**
     * shows the view-event-modal.html in the browser
     * 
     * @param {*} eventDetails contains the data required to prepopulate the modal with the existing event data
     */
    showViewEventModal : function(eventDetails) {
      //if a context is passed, add it to the view for onward use
      if (eventDetails.event.extendedProps.context) {
        $('#context').html(eventDetails.event.extendedProps.context);
        $('#context').attr('data-id', eventDetails.event.extendedProps.context_id);
      }

      $('.fc-popover').hide();
      $('.time_error').remove();
      $('#view-event-modal').modal('show');
      $('#view-event-modal').attr('data-event-id', eventDetails.event.id);

      // Sets event type and invitee
      if (eventDetails.event.extendedProps.type != '') {
        $('#view-type-heading').html(eventDetails.event.extendedProps.type);
      }

      // If there is a service linked to the event e.g. in the case of a referral appointment
      //display the name of the service
      if (eventDetails.event.extendedProps.service_name != '') {
        $('#linked-service-name').html(eventDetails.event.extendedProps.service_name);
      }
      
      if (eventDetails.event.extendedProps.invitee != '') {
        $('#view-invitee-container').removeClass('d-none');
        $('#view-invitee').html(eventDetails.event.extendedProps.invitee);
        $('#view-invitee').attr('data-mydexid', eventDetails.event.extendedProps.invitee_mydexid);
      }
      
      // Sets the input fields in the modal to be the data from the clicked event
      $('#view-title').html(eventDetails.event.title);
      $('#view-organiser').html(eventDetails.event.extendedProps.organiser);


      const regex = new RegExp(/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi);

      const locationContent = eventDetails.event.extendedProps.location;
      if (locationContent.match(regex)) {
        $('#view-location').html('<a href="'+locationContent+'">'+locationContent+'</a>');
      }else{
        $('#view-location').html(locationContent);
      }
      
      $('#view-description').html(eventDetails.event.extendedProps.description);

      // Formats and set start and end date/time
      let startDate = eventDetails.event.start.toString().replace(":00 GMT+0000 (Greenwich Mean Time)", "");
      let endDate = eventDetails.event.end.toString().replace(":00 GMT+0000 (Greenwich Mean Time)", "");
      $('#view-start-date').html(startDate);
      $('#view-end-date').html(endDate);

      //determine which buttons to display based on event status
      let status = eventDetails.event.extendedProps.status;
      myEvents.modifyEventViewBasedOnStatus(status);

    },

    /**
     * ** not currently in use **
     * shows the edit-event-modal.html in the browser
     * 
     * @param {*} eventDetails contains the data required to prepopulate the modal with the existing event data
     */
    showEditEventModal : function(eventDetails) {

      $('.fc-popover').hide();
      $('.time_error').remove();
      $('#edit-event-modal').modal('show');
      $('#edit-event-modal').attr('data-event-id', eventDetails.event.id);

      // Gets the event's data and time for the one selected and formats it correctly to be added to the input fields
      let startDate = eventDetails.event.start;
      let endDate = eventDetails.event.end;
      // Format date to yyyy-mm-dd
      let dateInput = startDate.toISOString().split('T')[0];
      // Get time from the date object
      let startTime = startDate.toLocaleTimeString('en-GB', {hour: '2-digit', minute: '2-digit'}).split(' ')[0];
      let endTime = eventDetails.event.end;
      
      // If the end time is the same as the start time then it will be set as null, 
      // this fixes that by setting the end time to be the same as the start time
      if(endTime == null){
        endTime = startTime;
        $('#edit-start-date').val(dateInput);
        $('#edit-end-date').val(dateInput);
      } else {
        $('#edit-start-date').val(dateInput);
        endTime = endTime.toLocaleTimeString('en-GB', {hour: '2-digit', minute: '2-digit',}).split(' ')[0];
        dateInput = endDate.toISOString().split('T')[0];
        $('#edit-end-date').val(dateInput);
      }

      // Sets event type and invitee
      $('#edit-type-heading').html(eventDetails.event.extendedProps.type);
      $('#edit-invitee-heading').html(eventDetails.event.extendedProps.invitee);

      // Sets the input fields in the modal to be the data from the clicked event
      $('#edit-start-time').val(startTime);
      $('#edit-end-time').val(endTime);
      $('#edit-title').val(eventDetails.event.title);
      $('#edit-organiser').val(eventDetails.event.extendedProps.organiser);
      $('#edit-location').val(eventDetails.event.extendedProps.location);
      $('#edit-description').val(eventDetails.event.extendedProps.description);
      $('#edit-type').val(eventDetails.event.extendedProps.type);
      $('#edit-invitee option:selected').val(eventDetails.event.extendedProps.invitee);
    },
    
    /**
     * adds event listeners to the event modals, add/edit and calls relevant event handler functions
     * 
     */
    addEventListeners : function() {
      $('#add-event').on('submit', function(event) {
        event.preventDefault();

        if(eventStartsBeforeItEnds("add")) {
          saveEvent();
        }

      })

      $('#delete-event').on('click', function() {

        deleteEvent();

      })

      $('#edit-event').on('submit', function(event) {
        event.preventDefault();

        if(eventStartsBeforeItEnds("edit")){
          editEvent();
        }

      })

      $('#accept-invite').on('click', function(event) {
        event.preventDefault();
        manageInvite("CONFIRMED");
      })

      $('#reject-invite').on('click', function(event) {
        event.preventDefault();
        manageInvite("REJECTED");
      })

      $('#viewAppointments').on('shown.bs.collapse', function(event) {
        event.preventDefault();
        populateAppointmentList();
      })

      //// Resets the modals / collapsible elements when closed ////
      $('#add-event-modal').on('hidden.bs.modal', function () {
        $(this).find('form').trigger('reset');
      })

      $('#view-event-modal').on('hidden.bs.modal', function () {
        $('#view-type-heading').html("My Event");
        $('#view-invitee-container').addClass('d-none');
        $('#view-invitee').html("");
        $('#view-invitee').attr('data-mydexid', "");

        $('#accept-invite').addClass('d-none');
        $('#reject-invite').addClass('d-none');
        $('#delete-event').addClass('d-none');

        $('#event-status-message').html("");
       
      })

      $('#viewAppointments').on('hidden.bs.collapse', function() {
        $('#appointmentList').html('');
      })

      eventTimeAdjuster();
      

    }

  }

  /////EVENT EVENT HANDLERS/////

  /**
   * Action to take when save/add event is clicked.
   * Gets the form data, formats it and calls the addEvent function (Ajax request) as defined in the Event entity (that is defined based on appType).
   * Then, if the request is successful, the saveEvent function, as defined by the consuming entity, is called - this manages what happens in the 
   * consuming entities UI.
   * 
   */
  function saveEvent() {
    // Get form data and add the event
    let form = getInputs("add");
    let promise = myEvents.addEvent(form, context, contextID);
      
    promise.then(function (response) {
      
      //handle what happens in the consuming entity and close the modal
      form.id = response.last_insert_id;
      eventHandlers.saveEvent(form);
      $("#add-event-modal").modal("hide");

    });
    promise.fail(function (err) {
      Util.toggleAlert('.alert', "This event has not been saved.", 'alert-warning');
    });
  }

  /**
   * Action to take when delete event is clicked.
   * Calls the delete Event function (Ajax request) as defined in the Event entity (that is defined based on appType).
   * Then, if the request is successful, the deleteEvent function, as defined by the consuming entity, is called - this manages what happens in the 
   * consuming entities UI.
   * 
   */
  function deleteEvent() {
    // Get the eventID of the event to be deleted and delete it
    let eventID = $('#view-event-modal').attr('data-event-id');
    let promise;
    if ($('#view-invitee').data('mydexid') != "") { //if there's an invitee, pass the event's context and invitee's mydexid to the request
      let context = [];
      context['name'] = $('#context').html();
      context['id'] = $('#context').data('id');
      let mydexid = $('#view-invitee').data('mydexid');
      promise = myEvents.deleteEvent(eventID, context, mydexid);
    } else {
      promise = myEvents.deleteEvent(eventID);
    }

    promise.then(function (response){

      //handle what happens in the consuming entity and close the modal
      eventHandlers.deleteEvent(eventID);
      $("#view-event-modal").modal("hide");

    });
    promise.fail(function (err) {
      Util.toggleAlert('.alert', "This event has not been deleted.", 'alert-warning');
    });
  }

  /**
   * Action to take when edit event is clicked.
   * Gets the form data. Calls the edit Event function (Ajax request) as defined in the Event entity (that is defined based on appType).
   * Then, if the request is successful, the editEvent function, as defined by the consuming entity, is called - this manages what happens in the 
   * consuming entities UI.
   * 
   */
  function editEvent() {

    // Get the form data and eventID to be updated and update that event
    let form = getInputs("edit");
    let eventID = $('#edit-event-modal').attr('data-event-id');
    let promise = myEvents.updateEvent(form, eventID);

    promise.then(function (response) {

      //handle what happens in the consuming entity and close the modal
      form.id = response.last_insert_id;
      eventHandlers.editEvent(eventID, form);
      $("#edit-event-modal").modal("hide");

    });
    promise.fail(function (response) {
      Util.toggleAlert('.alert', "This event has not been saved.", 'alert-warning');
    });
  }

  /**
   * Calls promises as defined by "myEvents" to update the status of the event and then respond to the invite
   * i.e. by updating the status of the other's equivalent record
   * Handles UI elements as defined by the consuming entitiy
   * @param {string} inviteStatus "CONFIRMED" or "REJECTED" determines the response to the event invite
   */
  function manageInvite(inviteStatus) {
    let form = {
      status: inviteStatus
    }
    let eventID = $('#view-event-modal').attr('data-event-id');

    $.when(

      myEvents.updateEvent(form, eventID).then(myEvents.handleInvite(inviteStatus, eventID))

    ).done(function() {

      //handle what happens in the consuming entity and close the modal
      eventHandlers.updateEventInviteResponse(eventID, inviteStatus);
      $("#view-event-modal").modal("hide");

    }).fail(function() {

      Util.toggleAlert('.alert', "Unable to save invite response at this time.", 'alert-warning');

    });

  }


  /////HELPER FUNCTIONS/////

  /**
   * Calls promise as defined by "myEvents" to get appointments
   * If there are none, adds a relevant message to appointments.html
   * Otherwise, adds a list of appointments to the collapsible element of appointments.html
   */
  function populateAppointmentList() {
    //set getAppointments promise and pass consumer localID e.g. this is the referralId in the context of a referral
    let getAppointments = myEvents.getAppointments(contextID, context);

    getAppointments.then(function(response) {
      let appointments = response.appointments;
      if (appointments.length == 0) {
        $('#appointmentList').append('<p class="text-center">You currently do not have any forthcoming appointments.</p>');
      } else {
        for (const index in appointments) {

          const appointment = appointments[index];
          const date = new Date(appointment.start_timestamp * 1000);
          const dateOptions = {
            dateStyle: "medium",
            timeStyle: "short",
            hour12: true
          };

          $('#appointmentList').append(
            '<li class="list-group-item"><div class="row"><div class="col-4">'
            + date.toLocaleString("en-GB", dateOptions) +
            '</div><div class="col-5">'
            + appointment.title +
            '</div><div class="col-3">'
            + appointment.status +
            '</div></div></li>'
            );
            
        }
      }

    });
    getAppointments.fail(function(err) {
      Util.toggleAlert('.alert', "There was a problem getting your appointment list.", 'alert-warning');
    });
  }

  /**
   * **not currently in use**
   * Top level function that handles/controls getting the invitee list from the consuming entity and then
   * populating the event modals' invitee select element with the invitees contained within the invitee list 
   */
  function populateInviteeList() {
    //get the invitee list from the consuming entity - this can be a promise that returns an array of objects,
    //or it can simply be an array of objects
    let inviteeList = consumer.getInviteeList();

    //check if the inviteeList provided by the consuming entity is a promise. 
    let inviteeListIsPromise = Boolean(inviteeList && typeof inviteeList.then == "function");

    if (inviteeListIsPromise) {
      inviteeList.then(function (response) {
  
        addInviteesToEventModal(response);
  
      });
      inviteeList.fail(function(err) {
        Util.toggleAlert('.alert', "There was a problem getting your invitee list.", 'alert-warning');
      })
    } else {
      addInviteesToEventModal(inviteeList);
    }
    
  }

 /**
  * Populates the select element for adding/editing the attendee/invitee with the inviteeList provided by the consuming entity
  * @param {*} inviteeList an array of invitees, each invitee element contains the mydexid and human readable name of the client
  */
  function addInviteesToEventModal(inviteeList) {
    if (inviteeList.length > 0) {
  
      //adds invitee options to add event modal
      $.each(inviteeList, function (i, invitee) {
        $('#add-invitee').append($('<option>', {
          value : invitee.invitee_name,
          text : invitee.invitee_name,
          id : invitee.mydexid
        }))
      })
  
      //adds invitee options to edit event modal
      $.each(inviteeList, function (i, invitee) {
        $('#edit-invitee').append($('<option>', {
          value : invitee.invitee_name,
          text : invitee.invitee_name,
          id : invitee.mydexid
        }))
      })

    } else {

      $('#add-invitee').append('<option id="no invitee selected" value="none">None</option>');

    }
  }

  /**
   * Gets the inputs from the form in the {}-event-modal
   * adds timestamps to the payload for writing to the backend
   * 
   * @param {*} type the type of event modal i.e. "add" or "edit"
   * @returns {*} form object containing all the inputs
   */
  function getInputs(type) {
    // Get the values from the form 
    let startDate = $('#' + type + '-start-date').val(); 
    let endDate = $('#' + type + '-end-date').val();
    let startTime = startDate + " " + $('#' + type + '-start-time').val();
    let endTime = endDate + " " + $('#' + type + '-end-time').val();

    let title = $('#' + type + '-title').val();
    let description = $('#' + type + '-description').val();
    // Convert start and end times to timestamp - needed for writing to backend.
    let startTimestamp = Date.parse(startTime) / 1000; 
    let endTimestamp = Date.parse(endTime) / 1000;
    let organiser = $('#' + type + '-organiser').val();
    let attendee = $('#' + type + '-invitee-heading').html();
    //TODO currently "status" is hardcoded here in the UI - should this be handled at the back end?
    let status = "TENTATIVE";
    let location = $('#' + type + '-location').val();
    let eventType = $('#' + type + '-type-heading').html();
     
    return {
      'start' : startTime,
      'end' : endTime,
      'mydexID' : inviteeMydexID,
      'title' : title,
      'description' : description,
      'start_timestamp' : startTimestamp, 
      'end_timestamp' : endTimestamp,
      'organiser' : organiser,
      'attendee' : attendee,
      'status' : status,
      'location' : location,
      'type' : eventType
    } 
  }

  /**
   * Checks that the event being saved doesn't start _after_ it has ended
   * Gets the start date / end date and start time / end time and makes a comparison
   * 
   * @param {*} type the type of event modal we are targetting i.e. "add" or "edit"
   * @returns {boolean} false if an event starts _after_ it has finished
   */
  function eventStartsBeforeItEnds(type) {

    let startDate = Date.parse($('#' + type + '-start-date').val());
    let endDate = Date.parse($('#' + type + '-end-date').val());
    let startTime = $('#' + type + '-start-time').val();
    let endTime = $('#' + type + '-end-time').val();

    if (endDate < startDate || endTime < startTime) {

      Util.toggleAlert('.alert', "End time has to be after start time.", 'alert-warning');
      return false;

    }

    return true;

  }

  /**
   * Adjusts the end_time field, if someone adjusts the start time to be in front of it
   * 
   * @returns {void}
   */
  function eventTimeAdjuster(){

    $('#add-start-time, #add-end-time').off('change').on('change', function(){

      var startTime = $('#add-start-time').val().split(':');
      var dateObjectStart = new Date();
      dateObjectStart.setHours( parseInt(startTime[0]) );
      dateObjectStart.setMinutes( parseInt(startTime[1]) );
      dateObjectStart.setSeconds(0, 0);
  
      var endTime = $('#add-end-time').val().split(':');
      var dateObjectEnd = new Date();
      dateObjectEnd.setHours( parseInt(endTime[0]) );
      dateObjectEnd.setMinutes( parseInt(endTime[1]) );
      dateObjectEnd.setSeconds(0, 0);

      if(dateObjectEnd <= dateObjectStart){
        dateObjectEnd = new Date(dateObjectStart.valueOf());
        dateObjectEnd.setHours ( dateObjectEnd.getHours() + 1 );

        var endHours = dateObjectEnd.getHours();
        var endMinutes = dateObjectEnd.getMinutes();
  
        if(String(endHours).length < 2){
          endHours = String(endHours).padStart(2, '0');
        }
  
        if(String(endMinutes).length < 2){
          endMinutes = String(endMinutes).padStart(2, '0');
        }
  
        $('#add-end-time').val(endHours + ':' + endMinutes);

      }

    });

    return;
  }

  return eventManager;

};


